function OrderOptionsSummary() {
    var selectedShapeState = React.useState(null);
    var selectedShape = selectedShapeState[0];
    var setSelectedShape = selectedShapeState[1];
    
    var selectedBladeState = React.useState(null);
    var selectedBlade = selectedBladeState[0];
    var setSelectedBlade = selectedBladeState[1];
    
    var selectedHandleState = React.useState(null);
    var selectedHandle = selectedHandleState[0];
    var setSelectedHandle = selectedHandleState[1];
    
    var bladeDataState = React.useState(null);
    var bladeData = bladeDataState[0];
    var setBladeData = bladeDataState[1];
    
    var handleDataState = React.useState(null);
    var handleData = handleDataState[0];
    var setHandleData = handleDataState[1];
    
    // poll state
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (typeof window.KnifeCustomizationState === 'undefined') return;
            
            if (window.KnifeCustomizationState.selectedShape !== selectedShape) {
                setSelectedShape(window.KnifeCustomizationState.selectedShape);
            }
            if (window.KnifeCustomizationState.selectedBlade !== selectedBlade) {
                setSelectedBlade(window.KnifeCustomizationState.selectedBlade);
            }
            if (window.KnifeCustomizationState.selectedHandle !== selectedHandle) {
                setSelectedHandle(window.KnifeCustomizationState.selectedHandle);
            }
            if (window.KnifeCustomizationState.selectedBladeData !== bladeData) {
                setBladeData(window.KnifeCustomizationState.selectedBladeData);
            }
            if (window.KnifeCustomizationState.selectedHandleData !== handleData) {
                setHandleData(window.KnifeCustomizationState.selectedHandleData);
            }
        }, 100);
        
        return function() { clearInterval(checkState); };
    }, [selectedShape, selectedBlade, selectedHandle, bladeData, handleData]);
    
    // shape info from globals
    var getShapeName = function(shapeId) {
        if (!shapeId) return null;
        var shape = mockKnifeShapes.find(function(s) { return s.id === shapeId; });
        return shape ? shape.name : null;
    };
    
    var getShapeImage = function(shapeId) {
        return shapeId && shapeImages[shapeId] ? shapeImages[shapeId] : '';
    };
    
    var getBladeImage = function() {
        if (!bladeData) return '';
        if (bladeData.metafields && bladeData.metafields['custom.customization_thumbnail']) {
            return bladeData.metafields['custom.customization_thumbnail'];
        }
        return bladeData.image || '';
    };
    
    var getHandleImage = function() {
        if (!handleData) return '';
        if (handleData.metafields && handleData.metafields['custom.customization_thumbnail']) {
            return handleData.metafields['custom.customization_thumbnail'];
        }
        return handleData.image || '';
    };
    
    var shapeName = getShapeName(selectedShape);
    var shapeImage = getShapeImage(selectedShape);
    var bladeImage = getBladeImage();
    var bladeName = bladeData ? bladeData.name : null;
    var handleImage = getHandleImage();
    var handleName = handleData ? handleData.name : null;
    
    return React.createElement('div', { className: 'options-summary-grid' },
        // shape
        React.createElement('div', null,
            React.createElement('div', { className: 'summary-option-card' },
                React.createElement('div', { className: 'summary-option-label' }, 'Knife Shape'),
                React.createElement('div', { className: 'summary-option-placeholder' },
                    shapeImage ? React.createElement('img', {
                        src: shapeImage,
                        alt: shapeName || 'Shape'
                    }) : '\u00A0'
                ),
                shapeName && React.createElement('div', { className: 'summary-option-name' }, shapeName)
            )
        ),
        // blade
        React.createElement('div', null,
            React.createElement('div', { className: 'summary-option-card' },
                React.createElement('div', { className: 'summary-option-label' }, 'Blade Type'),
                React.createElement('div', { className: 'summary-option-placeholder' },
                    bladeImage ? React.createElement('img', {
                        src: bladeImage,
                        alt: bladeName || 'Blade'
                    }) : '\u00A0'
                ),
                bladeName && React.createElement('div', { className: 'summary-option-name' }, bladeName)
            )
        ),
        // handle
        React.createElement('div', null,
            React.createElement('div', { className: 'summary-option-card' },
                React.createElement('div', { className: 'summary-option-label' }, 'Handle Type'),
                React.createElement('div', { className: 'summary-option-placeholder' },
                    handleImage ? React.createElement('img', {
                        src: handleImage,
                        alt: handleName || 'Handle'
                    }) : '\u00A0'
                ),
                handleName && React.createElement('div', { className: 'summary-option-name' }, handleName)
            )
        )
    );
}

window.OrderOptionsSummary = OrderOptionsSummary;